import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { IoIosArrowDown } from "react-icons/io";

const NavBarSubMenu = ({
  name,
  route,
  subMenu = false,
  border = false,
  subMenuData,
}) => {
  const [isVisible, setVisible] = useState({ open: false, location: "" });

  const toggleSubMenuEnter = (getLink) => {
    setVisible({ ...isVisible, open: true, location: getLink });
  };
  const toggleSubMenuLeave = () => {
    setVisible({ ...isVisible, open: false, location: "" });
  };
 
  return (
    <>
      {subMenu ? (
        <div
          onMouseEnter={() => toggleSubMenuEnter(route)}
          onMouseLeave={toggleSubMenuLeave}
          className="text-[10px] xl:text-xs"
        >
          <div
            className={`${border ? "border-r border-r-yellow" : "border-none"}`}
          >
            <NavLink
              to={route}
              
              className={({ isActive }) =>
              `px-4 py-0 flex justify-evenly items-center text-[10px] xl:text-xs hover:text-yellow ${
                isActive ? "text-yellow" : "text-black"
              }`
            }  
            >
              <span className="hover:text-yellow flex justify-evenly items-center">
                {name}&nbsp;&nbsp;
                <IoIosArrowDown size={12} className="hover:text-yellow" />
              </span>
            </NavLink>
          </div>

          {/* sub-page modal for sub Menu */}
          {isVisible.open && isVisible.location === route && (
            <div className="absolute z-50 flex flex-col gap-1 p-2 bg-gray text-[10px] rounded-b-sm">
              {subMenuData.map((item, index) => (
                <NavLink
                  to={item.sub_route}
                  className="px-4 py-2 hover:text-yellow bg-white uppercase"
                  key={index}
                >
                  {item.name}
                </NavLink>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div
          className={`${
            border ? "border-r border-r-yellow" : ""
          } hover:rounded`}
        >
          <NavLink
            to={route}
            className={({ isActive }) =>
              `px-4 py-0 flex justify-evenly items-center text-[10px] xl:text-xs hover:text-yellow ${
                isActive ? "text-yellow" : "text-black"
              }`
            }
          >
            <span className="hover:text-yellow">{name}</span>
          </NavLink>
        </div>
      )}
    </>
  );
};

export default NavBarSubMenu;
